import { useDispatch, useSelector, useStore } from "react-redux";
import type { SignupDispatch, RootState } from ".";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useSignupDispatch = useDispatch.withTypes<SignupDispatch>();
export const useSignupSelector = useSelector.withTypes<RootState>();
export const useSignupStore = () => useStore<RootState>();
